function menuFixed() {
    var menu = $('header .menu-lg'),
        heightHeader = menu.height(),
        lastScrollTop = 0;

    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        $('.menu-lg').css({'transition': '.25s ease-in-out'});

        if (st > $('.main-screen').height() - heightHeader) {
            menu.addClass('menu-up');
        } else {
            menu.removeClass('menu-up');
        }

        if (st < lastScrollTop) {
            menu.removeClass('menu-up');
        }

        lastScrollTop = st;
    });
}

function show_quotes() {
    var result = '';
    $.ajax({
        url: "/actions/trading/quotes.json",
        async: false,
        cache: false,
        success: function(data) {
            result = data;
            //quotes_decode(data);
        }
    });
    return result;
};

function quotes_decode(qJOSN) {
    $.each(qJOSN, function (key, data) {
        $('#' +key+ ' .updown').css('display', 'none');
        $('#' +key+ ' .quotes-' +data['updown']).css('display', 'inline-block');
        $('#' +key+ ' .bid').text(data['bid']);
        $('#' +key+ ' .ask').text(data['ask']);
        $('#' +key+ ' .spread').text(data['spread'].toFixed(1));
    });
}

$(function () {
    $("[rel='tooltip']").tooltip();
});

$(document).ready(function () {
    menuFixed();
    if ($('.table-quotes').length > 0) {
        //show_quotes();
        quotes_decode($.parseJSON(show_quotes()));
        setInterval(function (){
            var quotes = $.parseJSON(show_quotes());
            quotes_decode(quotes);
        }, 4000);
    }

    $(".ripple").on("click", function (event) {
        $(this).append("<span class='ripple-effect'>");
        $(this).find(".ripple-effect").css({
            left: event.pageX - $(this).position().left,
            top: event.pageY - $(this).position().top
        }).animate({
            opacity: 0,
        }, 1500, function () {
            $(this).remove();
        });
    });

    $('#pills-calendar-tab').on('show.bs.tab', function (e) {
        if ($("#economicCalendarJs").length == 0) {
            $('#pills-calendar').prepend('<script id="economicCalendarJs" type="text/javascript" src="https://c.mql5.com/js/widgets/calendar/widget.js?6"></script><div id="economicCalendarWidget"></div>');
        }
    });

    $('#pills-calendar-tab').on('shown.bs.tab', function (e) {
        if ($("#economicCalendarCode").length == 0) {
            $('#pills-calendar').prepend('<script id="economicCalendarCode" type="text/javascript">new economicCalendar({ width: "100%", height: "660px", mode: 2, lang: "en" });</script>');
        }
    });

    $('.modal').on('show.bs.modal', function (e) {
        $('.menu-lg').css({'transition': 'none', 'padding-right': '17px'});
    });
    $('.modal').on('hidden.bs.modal', function (e) {
        $('.menu-lg').css({'padding-right': '0'});
    });

    $('input[type="file"]').change(function() {
        var val = $(this).val();

        console.log('change');
        if ($(this).val() != '') {
            $(this).next().text(val.substr(12));
        } else {
            $(this).next().text($(this).data('text'));
        }
    });

    $('input').focusout(function() {
        if ($(this).val() != '') {
            $(this).addClass('focus');
        } else {
            $(this).removeClass('focus');
        }
    });

    /*---Validator Defaults set---*/
    $.validator.setDefaults({
        errorPlacement: function(error,element) {
            return true;
        }
    });
    /*---end Validator Defaults set---*/

    /*---Demo Form---*/
    $('.demo-modal .btn').click(function() {
        $('#demo-form').submit();
    });

    $('#demo-form').validate({
        highlight: function (element) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid');
        },

        submitHandler: function(form){
            var show = 1;

            $('.demo-modal').modal('hide').on('hidden.bs.modal', function (e) {
                $('.success-modal .m-title').text($('#demo-form').data('title'));
                $('.success-modal .m-text').html('<p class="text-light mb-4 font-weight-bolder">'+$('.success-modal .m-text').data('wait')+'</p><div class="d-flex justify-content-center"><div class="spinner-border text-light" role="status"><span class="sr-only">'+$('.success-modal .m-text').data('loading')+'</span></div></div><p class="text-center text-light pl-3">'+$('.success-modal .m-text').data('loading')+'</p>');

                if (show == 1) {
                    $('.success-modal').modal('show');
                }
            });
            $(form).ajaxSubmit({
                url: '/actions/demo/wr_register.php',
                clearForm: true,
                success: function (data) {
                    $('.success-modal .m-text').html($('#demo-form').data('success'));
                    $('#demo-form select option:first').prop('selected', true);
                    $('#demo-form .focus').each(function () {
                        $(this).removeClass('focus');
                    });
                    show = 0;
                }
            });
        }
    });
    /*---End Demo Form---*/

    /*---Live Form---*/
    $('.live-modal .btn').click(function() {
        $('#live-form').submit();
    });

    $('#live-form').validate({
        highlight: function (element) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid');
        },

        submitHandler: function(form){
            var show = 1;

            $('.live-modal').modal('hide').on('hidden.bs.modal', function (e) {
                $('.success-modal .m-title').text($(form).data('title'));
                $('.success-modal .m-text').html('<p class="text-light mb-4 font-weight-bolder">'+$('.success-modal .m-text').data('wait')+'</p><div class="d-flex justify-content-center"><div class="spinner-border text-light" role="status"><span class="sr-only">'+$('.success-modal .m-text').data('loading')+'</span></div></div><p class="text-center text-light pl-3">'+$('.success-modal .m-text').data('loading')+'</p>');

                if (show == 1) {
                    $('.success-modal').modal('show');
                }
            });
            $(form).ajaxSubmit({
                url: '/actions/reg/reg.php',
                clearForm: true,
                success: function (data) {
                    let response = $.parseJSON(data);
                    if (response['res'] === 'error') {
                        $('.success-modal .modal-content').removeClass('bg-green-linear').addClass('bg-danger');
                        $('.success-modal .m-title').text('ERROR');
                        $('.success-modal .m-text').html('<p>'+response['code']+'</p>');
                    } else {
                        $('.success-modal .m-text').html($(form).data('text'));
                        $('#live-form .focus').each(function () {
                            $(this).removeClass('focus');
                        });
                        $('#live-form select').each(function(){
                            $(this).find('option:first').prop('selected', true);
                        });
                        $('input[type="file"]').each(function(){
                            $(this).next().text($(this).data('text'));
                        });
                        show = 0;
                    }
                }
            });
        }
    });
    /*---End Live Form---*/

    /*---Managed Form---*/
    $('.managed-form-modal .btn').click(function() {
        $('#managed-form').submit();
    });

    $('#managed-form').validate({
        highlight: function (element) {
            $(element).addClass('is-invalid');
            if ($(element).attr('type') == 'radio') {
                $(element).parent().parent().parent().addClass('is-invalid');
            }
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid');
            $(element).parent().parent().parent().removeClass('is-invalid');
        },

        submitHandler: function(form){
            var show = 1;
            $('.managed-form-modal').modal('hide').on('hidden.bs.modal', function (e) {
                $('.success-modal .m-title').text($(form).data('title'));
                $('.success-modal .m-text').html('<p class="text-light mb-4 font-weight-bolder">'+$('.success-modal .m-text').data('wait')+'</p><div class="d-flex justify-content-center"><div class="spinner-border text-light" role="status"><span class="sr-only">'+$('.success-modal .m-text').data('loading')+'</span></div></div><p class="text-center text-light pl-3">'+$('.success-modal .m-text').data('loading')+'</p>');
                if (show == 1) {
                    $('.success-modal').modal('show');
                }
            });
            $(form).ajaxSubmit({
                url: '/actions/managed/subscribe.am.php',
                clearForm: true,
                success: function (data) {
                    $('.success-modal .m-text').html($(form).data('success'));
                    $('#managed-form .focus').each(function () {
                        $(this).removeClass('focus');
                    });
                    $('#managed-form select').each(function(){
                        $(this).find('option:first').prop('selected', true);
                    });
                    $('input[type="file"]').each(function(){
                        $(this).next().text($(this).data('text'));
                    });
                    show = 0;
                }
            });
        }
    });
    /*---End Managed Form---*/

    /*---Contact form ---*/
    $('.contact-form').validate({
        highlight: function (element) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid');
        },

        submitHandler: function(form){
            var show = 1;

            $('.demo-modal').modal('hide').on('hidden.bs.modal', function (e) {
                $('.success-modal .m-title').text($('#demo-form').data('title'));
                $('.success-modal .m-text').html('<p class="text-light mb-4 font-weight-bolder">'+$('.success-modal .m-text').data('wait')+'</p><div class="d-flex justify-content-center"><div class="spinner-border text-light" role="status"><span class="sr-only">'+$('.success-modal .m-text').data('loading')+'</span></div></div><p class="text-center text-light pl-3">'+$('.success-modal .m-text').data('loading')+'</p>');

                if (show == 1) {
                    $('.success-modal').modal('show');
                }
            });
            $(form).ajaxSubmit({
                clearForm: true,
                success: function (data) {
                    console.log(data);
                    $('.success-modal .m-text').html($('#demo-form').data('success'));
                    $('#demo-form select option:first').prop('selected', true);
                    $('#demo-form .focus').each(function () {
                        $(this).removeClass('focus');
                    });
                    show = 0;
                }
            });
        }
    });
    /*---End Contact form ---*/

    $('#open-subscribe-form').validate({
        highlight: function (element) {
            $(element).addClass('is-invalid');
        },
        unhighlight: function (element) {
            $(element).removeClass('is-invalid');
        },

        submitHandler: function (form) {
            $(form).ajaxSubmit({
                url: '/actions/open_subscribe.php',
                clearForm: true,
                success: function (data) {

                }
            });
        }
    });

    /*---Login form---*/
    // $('loginLoginForm').
    /*---end Login form---*/
});